module.exports = "https://web-assets.ifttt.com/packs/media/docs/new_applet-1f8631ca.png";